import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Grid2,
    Stack,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    IconButton,
    Tooltip,
    TextField,
    Autocomplete,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TableComponent from "components/grid";
import { useDispatch } from "store";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import PaginationComponent from "components/ui-components/PaginationComponent";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { IoMdClose, IoMdSearch } from "react-icons/io";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { useGetAllPMQuery } from "store/slices/apis/pmPackageSlice";
import { useEditKeyPMMutation } from "store/slices/apis/keyPMSlice";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import time from "assets/time.png";
import editLogo from "assets/EditIcon.svg";
import { AddAlarm, Cancel, Edit, Save } from "@mui/icons-material";
import { MdCancel, MdOutlineEdit, MdSaveAs } from "react-icons/md";
import { FaCheck } from "react-icons/fa6";
import { useGetAllManpowerQuery, useUpdateManpowerMutation } from "store/slices/apis/manpowerSlice";
import ProceedActualDetail from "./ProceedActualDetail";
import {ReactComponent as SearchIcon} from "assets/PwC_Funct_Icons_Search_Outline_Black_RGB.svg"
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"

const categories = [
    { label: "Fasade Concrete", year: 1994 },
    { label: "Fasade Plaster", year: 1972 },
    { label: "Mason Concrete", year: 1973 }
];

const AllManpowerProductivity = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const theme = useTheme();
    const [pageNumber, setPageNumber] = useState(1);
    const [fromDate, setFromDate] = useState(null);
    const [open, setOpen] = useState(false);
    const [toDate, setToDate] = useState(null);
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        category: ""
    });
    const [category, setCategory] = useState('');

    const { projectId } = useParams();
    const {
        data: allmanpowerTrackingList,
        refetch,
        isLoading,
    } = useGetAllManpowerQuery({
        ProjectId: projectId,
        sortBy: "createddate",
        sortOrder: "desc",
        fromDate: filters?.fromDate,
        toDate: filters?.toDate,
        category: filters?.category,
        page: pageNumber,
        pageSize: 10,
    });

    const [updateManpower, updateManpowerRes] = useUpdateManpowerMutation();

    const [actualValues, setActualValues] = useState([]);


    const handleAddFields = (rowId) => {
        let editFields = {
            id: rowId?.id,
            actual_qty: "",
            actual_manpower: "",
            category: rowId?.category,
            date: rowId?.date,
            perDayQuantity: rowId?.perDayQuantity,
            plannedManpower: rowId?.plannedManpower
        }
        setActualValues([...actualValues, editFields])
    };

    const handleRemoveFields = (index) => {
        let result = [...actualValues];
        result.splice(index, 1)
        setActualValues(result)
    }

    const columns = [
        {
            name: "Manpower ID",
            field: "manpowerNumber",
            renderer(params) {
                return (
                    <Stack direction="row" spacing={1}>
                        {params?.manpowerNumber &&
                            <Chip label={params?.manpowerNumber} size="small" sx={{
                                fontSize: '12px',
                                '& .MuiChip-label': {
                                    paddingLeft: '8px',
                                    paddingRight: '8px',
                                    fontWeight: 600
                                }
                            }} />
                        }
                    </Stack>
                );
            }
        },
        {
            name: "Category",
            field: "category"
        },
        {
            name: "Date",
            field: "date"
        },
        {
            name: "Plan Qty",
            field: "perDayQuantity"
        },
        {
            name: "Plan Manpower",
            field: "plannedManpower"
        },
        {
            name: "Actual Qty",
            field: "actualQuantity",
            renderer: (params) => {
                let result = actualValues.map((a) => a.id);
                const isEditing = result?.includes(params.id)
                var index = result.indexOf(params.id);
                const currentValue = actualValues[index];

                if (isEditing) {
                    const error = currentValue?.errors?.actual_qty;
                    return (
                        <Stack direction="row" spacing={1} alignItems="center">
                            <TextField
                                size="small"
                                value={actualValues?.[index]?.actual_qty}
                                name='actual_qty'
                                onChange={event => handleFormChange(index, event)}
                                error={error}
                                helperText={error}
                            />
                        </Stack>
                    );
                }

                return (
                    <Stack direction="row" spacing={1} alignItems="center">
                        <span>{params['actualQuantity']}</span>
                    </Stack>
                );
            },
        },
        {
            name: "Actual Manpower",
            field: "actualManpower",
            renderer: (params) => {

                let result = actualValues.map((a) => a.id);
                const isEditing = result?.includes(params.id)
                var index = result.indexOf(params.id);

                const currentValue = actualValues[index];
                if (isEditing) {
                    const error = currentValue?.errors?.actual_manpower;
                    return (
                        <Stack direction="row" spacing={1} alignItems="center">
                            <TextField
                                size="small"
                                value={actualValues?.[index]?.actual_manpower}
                                name='actual_manpower'
                                onChange={event => handleFormChange(index, event)}
                                error={error}
                                helperText={error}
                            />
                        </Stack>
                    );
                }

                return (
                    <Stack direction="row" spacing={1} alignItems="center">
                        <span>{params['actualManpower']}</span>
                    </Stack>
                );
            },
        },
        {
            name: "Edit Action",
            renderer: (params) => {
                let result = actualValues.map((a) => a.id);
                const isEditing = result?.includes(params.id)
                var index = result.indexOf(params.id);
                if (isEditing) {
                    return (
                        <Stack direction="row" spacing={1} alignItems="center">
                            <IconButton
                                onClick={() => handleRemoveFields(index)}
                                size="small"
                                color="error"
                                sx={{ padding: 0 }}
                            >
                                <IoMdClose style={{ fontSize: 'large' }} />
                            </IconButton>
                        </Stack>
                    );
                } else {
                    return (
                        <Stack direction="row" spacing={1} alignItems="center">
                            <IconButton
                                onClick={() => handleAddFields(params)}
                                size="small"
                                color="success"
                                sx={{ padding: 0 }}
                            >
                                <MdOutlineEdit style={{ fontSize: 'large' }} />
                            </IconButton>
                        </Stack>
                    );
                }

            },
        }
    ];

    const handleValuesValid = () => {
        let isFormValid = true;
        actualValues?.map((val, index) => {
            Object.keys(val).forEach((x) => {
                if (x == 'errors') {
                    if (Object.keys(val[x]).length > 0) {
                        return isFormValid = false;
                    }
                }
                if (!val[x]) {
                    isFormValid = false;
                }
            });
        })
        return isFormValid;
    }

    const handleFormChange = (index, event) => {
        const { name, value } = event.target;
        setActualValues((prev) => {
            const updated = [...prev];
            const row = { ...updated[index] };

            row[name] = value;

            const errors = row.errors || {};
            if (!value) {
                errors[name] = "This field is required";
            } else if (isNaN(value)) {
                errors[name] = "Must be a number";
            } else {
                delete errors[name];
            }

            row.errors = errors;
            updated[index] = row;
            return updated;
        });
    };

    const handleProceedActual = () => {
        setOpen(true);

    }

    const handleApprove = () => {
        updateManpower({ body: actualValues }).unwrap();

    }
    const handleCancelProceedActual = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (updateManpowerRes?.isSuccess) {
            if (updateManpowerRes?.data?.status == 'Success') {
                openNotification(updateManpowerRes?.data?.message, 'success')
            } else {
                openNotification(updateManpowerRes?.data?.message, 'success')
            }
            navigate(`/projects/${projectId}/key-manpower/pending-approval-manpower`);
            handleCancelProceedActual()
            setActualValues([]);
        }
    }, [updateManpowerRes?.isSuccess]);

    useEffect(() => {
        if (updateManpowerRes?.isError) {
            openNotification('something went problems!', 'error')
        }
    }, [updateManpowerRes?.isError]);

    const openNotification = async (msg, type = 'error') => {

        await dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );

        setTimeout(() => dispatch(closeSnackbar()), 3000);

    };
    const CustomCalendarIcon = (props) => (
        <CalendarIcon {...props} style={{ width: 26, height: 26, fill:"#696969 ", stroke:"#696969", strokeWidth:4 }} />
      );
    

    return (
        <>
            <Grid2 container spacing={2} sx={{ mt: "20px" }}>
                <Grid2 size={12}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: { xs: 'start', sm: 'center' },
                            justifyContent: "space-between",
                            flexDirection: { xs: 'column', sm: 'row' }
                        }}
                    >
                        <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={2}
                            sx={{
                                // flexGrow: 2,
                                alignItems: { xs: "stretch", sm: "center" },
                                width: { xs: '100%', sm:'none', md:'none', lg:'none' },
                                "& .MuiStack-root": {
                                    paddingTop: "15px",
                                },
                            }}
                        >
                            <Autocomplete
                                options={categories}
                                getOptionLabel={(option) => option?.label}
                                onChange={(_, newValue) =>
                                    setCategory(newValue ? newValue?.label : '')
                                }
                                value={categories?.find((option) => option.label === category) || null}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Category"
                                        name="currentStatus"
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                padding: '8px !important', 
                                            },
                                        }}
                                    />
                                )}
                                ListboxProps={{
                                    sx: { fontSize: '13px' },
                                }}
                                sx={{
                                    width: {
                                        xs: '100%',
                                        sm: '17%',
                                        md: '17%',
                                        lg: '17%'
                                    },
                                    marginTop: '15px !important'
                                }}
                            />
                            <LocalizationProvider dateAdapter={AdapterDayjs} size="small">
                                <DemoContainer components={["DatePicker", "DatePicker"]}>
                                    <DatePicker
                                        label="From Date"
                                        value={fromDate}
                                        format="DD-MM-YYYY"
                                        onChange={(newValue) => setFromDate(newValue)}
                                        slots={{
                                            openPickerIcon: CustomCalendarIcon,
                                        }}
                                        slotProps={{
                                            textField: {
                                                sx: {
                                                    minWidth: 100,
                                                    "& .MuiOutlinedInput-input": {
                                                        padding: "10px",
                                                    },

                                                    "& .MuiInputLabel-root": {
                                                        top: "-6px",
                                                    },
                                                },
                                            },
                                            field: {
                                                clearable: true,
                                                onClear: () =>
                                                    setFilters({
                                                        fromDate: "",
                                                        toDate: toDate
                                                            ? dayjs(toDate).format("YYYY-MM-DD")
                                                            : "",
                                                    }),
                                            },
                                        }}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={["DatePicker", "DatePicker"]}>
                                    <DatePicker
                                        label="To Date"
                                        value={toDate}
                                        format="DD-MM-YYYY"
                                        clearable={true}
                                        onChange={(newValue) => setToDate(newValue)}
                                        slots={{
                                            openPickerIcon: CustomCalendarIcon,
                                        }}
                                        slotProps={{
                                            textField: {
                                                sx: {
                                                    minWidth: 100,
                                                    "& .MuiOutlinedInput-input": {
                                                        padding: "10px",
                                                    },

                                                    "& .MuiInputLabel-root": {
                                                        top: "-6px",
                                                    },
                                                },
                                            },
                                            field: {
                                                clearable: true,
                                                onClear: () =>
                                                    setFilters({
                                                        fromDate: fromDate
                                                            ? dayjs(fromDate).format("YYYY-MM-DD")
                                                            : "",
                                                        toDate: "",
                                                    }),
                                            },
                                        }}
                                    />
                                </DemoContainer>
                            </LocalizationProvider>
                            <Button
                                loading={isLoading}
                                onClick={() => {
                                    setFilters({
                                        fromDate: fromDate
                                            ? dayjs(fromDate).format("YYYY-MM-DD")
                                            : "",
                                        toDate: toDate ? dayjs(toDate).format("YYYY-MM-DD") : "",
                                        category: category
                                    });
                                }}
                                size="large"
                                // startIcon={<IoMdSearch />}
                                startIcon={<SearchIcon style={{ height: "20px", width: "20px", fill:`${theme?.customSettings?.themeColor}` }} />}
                                variant="outlined"
                                sx={{
                                    color: `${theme?.customSettings?.themeColor}`,
                                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                                    background: "none",
                                    textTransform: "inherit",
                                    padding: "6px 15px",
                                    marginTop: "12px !important",
                                }}
                            >
                                Search
                            </Button>
                            <Button
                                loading={isLoading}
                                onClick={() => {
                                    setCategory("");
                                    setFromDate(null)
                                    setToDate(null)
                                    const clearedValues = Object.fromEntries(
                                        Object.keys(filters).map(key => [key, ""])
                                    );
                                    setFilters(clearedValues);
                                }}
                                size="large"
                                variant="outlined"
                                sx={{
                                    color: `${theme?.customSettings?.themeColor}`,
                                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                                    background: "none",
                                    textTransform: "inherit",
                                    padding: "6px 15px",
                                    marginTop: "12px !important",
                                }}
                            >
                                Reset
                            </Button>
                        </Stack>
                        {
                            actualValues?.length > 0 &&
                            <Button
                                variant="contained"
                                // startIcon={<MdSaveAs sx={{ marginBottom: "2px" }} />}
                                disabled={!handleValuesValid()}
                                onClick={handleProceedActual}
                                loading={updateManpowerRes?.isLoading}
                                sx={{
                                    backgroundColor: `${theme?.customSettings?.themeColor}`,
                                    color: "#FFF",
                                    padding: "5px 20px",
                                    fontWeight: "500",
                                    textTransform: "none",
                                    fontSize: "16px",
                                    marginTop: "11px",
                                    border: `1px solid ${theme?.customSettings?.themeColor}`,
                                    '&.Mui-disabled': {
                                        border: 'none'
                                    }
                                }}
                            >
                                Save
                            </Button>
                        }

                    </Box>
                </Grid2>
                <Grid2 size={12} sx={{ mt: 2 }}>
                    <TableComponent
                        columns={columns}
                        data={allmanpowerTrackingList?.data?.manpowerTracking}
                        type="border"
                        isLoading={isLoading}
                    />
                    {!isLoading && (
                        <Box sx={{ display: "flex", justifyContent: "end" }}>
                            <PaginationComponent
                                pageNumber={allmanpowerTrackingList?.data?.pagination?.currentPage || 1}
                                totalPages={allmanpowerTrackingList?.data?.pagination?.totalPages || 1}
                                onPageChange={setPageNumber}
                            />
                        </Box>
                    )}
                </Grid2>
            </Grid2 >
            <ProceedActualDetail open={open} cancel={handleCancelProceedActual} actualValues={actualValues} handleApprove={handleApprove} updateManpowerRes={updateManpowerRes} />
        </>
    );
}

export default AllManpowerProductivity;
